import { makeSx } from '../../../../../theme/_utils'
import { defaultPalette } from '../../../../../theme/idsTheme'

export default makeSx({
    helperTextContainer: {
        padding: '0 1rem',
        marginTop: '-0.75rem',
    },
    attachmentOrgTextBase: {
        fontSize: '0.875rem',
        color: defaultPalette.typography.half,
    },
    attachmentOrgTextError: {
        color: defaultPalette.error.main,
    },
})
